import React from "react";
import Link from "./link";
import ImageLoader from "../commons/image-loader";

const HighlightSeal = (props) => {
  const { url, images, bottom } = props;

  const WrapperComponent = url ? Link : "div";

  return (
    <div className={`seal-highlight ${bottom ? 'seal-highlight-bottom' : ''}`}>
      <WrapperComponent to={url}>
        <ImageLoader source={images?.[0]?.downloadURL} ratio={"1:1"} />
      </WrapperComponent>
    </div>
  );
};

export default HighlightSeal;
